(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-search-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.mobile-search-input');
  const predictiveSearch = document.querySelector('.predictive-search');
  const suggestionsList = document.querySelector('.suggestions-list');
  const productsList = document.querySelector('.products-list');

  let debounceTimer;

  searchInput.addEventListener('input', function(e) {
    clearTimeout(debounceTimer);
    const searchTerm = e.target.value;

    if (searchTerm.length < 1) {
      predictiveSearch.classList.remove('active');
      return;
    }

    debounceTimer = setTimeout(() => {
      // Use Shopify's predictive search API
      fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,collection,article,page&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,variants.title`)
        .then(response => response.json())
        .then(data => {
          suggestionsList.innerHTML = '';
          productsList.innerHTML = '';

          // Build search term suggestions based on results
          const searchSuggestions = new Set();
          
          // Add base search term
          searchSuggestions.add(searchTerm.toLowerCase());

          // Add suggestions from product types
          if (data.resources.results.products) {
            data.resources.results.products.forEach(product => {
              if (product.product_type) {
                searchSuggestions.add(`${searchTerm} ${product.product_type.toLowerCase()}`);
              }
              if (product.vendor) {
                searchSuggestions.add(`${searchTerm} ${product.vendor.toLowerCase()}`);
              }
            });
          }

          // Add collection titles as suggestions
          if (data.resources.results.collections) {
            data.resources.results.collections.forEach(collection => {
              searchSuggestions.add(collection.title.toLowerCase());
            });
          }

          // Render suggestions
          [...searchSuggestions].slice(0, 6).forEach(suggestion => {
            const div = document.createElement('div');
            div.className = 'suggestion-item';
            div.textContent = suggestion;
            div.addEventListener('click', () => {
              searchInput.value = suggestion;
              window.location.href = `/search?q=${encodeURIComponent(suggestion)}`;
            });
            suggestionsList.appendChild(div);
          });

          // Render products
          if (data.resources.results.products) {
            data.resources.results.products.forEach(product => {
              const div = document.createElement('div');
              div.className = 'product-item';
              div.innerHTML = `
                <img src="${product.featured_image?.url || ''}" alt="${product.title}" class="product-image">
                <span class="product-title">${product.title}</span>
              `;
              div.addEventListener('click', () => {
                window.location.href = product.url;
              });
              productsList.appendChild(div);
            });
          }

          predictiveSearch.classList.add('active');
        })
        .catch(error => {
          console.error('Error fetching search suggestions:', error);
        });
    }, 300);
  });

  // Close predictive search when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.mobile-search-form')) {
      predictiveSearch.classList.remove('active');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-search"]) return;
  try {
    
  // Add any custom JavaScript here if needed

  } catch(e) { console.error(e); }
})();
})();
